module.exports = __webpack_public_path__ + "media/images/flags/32/Antigua-and-Barbuda-a6fbf5433e9cdb24ad577a6154a3de41.png";